import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetch, reset } from '../../actions'
import { fetchByAgreement as fetchDriver, reset as resetDriverFlags } from 'features/drivers/actions'
import DrillDownModal from './drill-down-modal'

const DrillDownModalContainer = (props) => {
  const { id } = useParams()

  return <ConnectedDrillDownModal {...props} routeId={id} />
}

const mapStateToProps = ({ drivers, fleet, reportVehicleServicing, settings }, { routeId }) => ({
  agreementNo: routeId,
  data: fleet.data?.[routeId],
  fleetIds: settings.fleet.selected,
  fleetFlags: fleet.flags,
  driverFlags: drivers.flags,
  serviceBookingFlags: reportVehicleServicing.flags,
  errorMessage: fleet.errorMessage,
})

const mapDispatchToProps = (dispatch) => ({
  onFetch: (agreementNo, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetch(null, {
      resourceId: agreementNo,
      queryParams: { FleetId }
    }))
  },
  onFetchDriver: (agreementNo, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetchDriver(null, {
      resourceId: agreementNo,
      queryParams: { FleetId }
    }))
  },
  onReset: () => dispatch(reset()),
  onResetDriverFlags: () => dispatch(resetDriverFlags()),
})

const ConnectedDrillDownModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(DrillDownModal)

export default DrillDownModalContainer
